module.exports = __webpack_public_path__ + "img/Group 5360.84d8a642.png";